// src/contexts/InstallPromptContext.tsx
import React, { createContext, useContext } from "react";
import { useInstallPrompt as useRawHook } from "../hooks/useInstallPrompt";

interface InstallPromptContextType {
  showPrompt: boolean;
  promptInstall: () => Promise<void>;
  dismissPrompt: () => void;
  setShowPrompt: (v: boolean) => void;
}

const InstallPromptContext = createContext<InstallPromptContextType | null>(null);

export const InstallPromptProvider: React.FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const raw = useRawHook();
  return (
    <InstallPromptContext.Provider value={raw}>
      {children}
    </InstallPromptContext.Provider>
  );
};

// custom hook that just reads from ctx
export function useInstallPrompt() {
  const ctx = useContext(InstallPromptContext);
  if (!ctx) {
    throw new Error("useInstallPrompt must be used within InstallPromptProvider");
  }
  return ctx;
}